import React, { useEffect, useState } from 'react';
import { Icon } from 'react-icons-kit'
import { ic_search } from 'react-icons-kit/md/ic_search'
import { ic_delete } from 'react-icons-kit/md/ic_delete'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import NavBar from '../components/NavBar'
import FrTable from '../components/FrTable'
import FrSelect from '../components/FrSelect'
import UserOptions from '../components/UserOptions'
import FrLoading from '../components/FrLoading'
import FooterDelphus from '../components/FooterDelphus'
import FrDatePicker from '../components/FrDatePicker'

import api from '../services/api'
import { paramsToObject, formToObject, populateForm, objectToQueryString, getUserCode } from '../utils/functions'

import './styles/DefaultMainScreen.css';
import './styles/Manut.css';

const swal = withReactContent(Swal)

function Contratos(props) {
  const [data, setData] = useState([])
  const [filter, setFilter] = useState({})
  const [filtered, setFiltered] = useState(false)
  const [selected, setSelected] = useState([])
  const [comboAtivo, setComboAtivo] = useState([{ value: ' and (data_cancelamento is null and (data_fim is null or data_fim > current_date))', display: 'Ativo' },
  { value: 'and (data_cancelamento is not null or data_fim <= current_date)', display: 'Inativo' }
  ])
  const [comboAdimplente, setComboAdimplente] = useState([{ value: 'S', display: 'Adimplentes' },
  { value: 'N', display: 'Inadimplentes' }
  ])
  const [comboSed, setComboSed] = useState([{ value: '', display: '' }])

  const columns = [
    { id: 'pk_cto', numeric: false, label: 'Nº Contrato', align: 'left', minWidth: 50 },
    { id: 'nomecli', numeric: false, label: 'Cliente', align: 'left', minWidth: 200 },
    { id: 'ultima_parcela', numeric: false, label: 'Última Parcela Paga', align: 'left', minWidth: 200 },
    { id: 'data_fim', date: true, numeric: false, label: 'Data Vencimento', align: 'left', minWidth: 200 },
    { id: 'renova_automatico', numeric: false, label: 'Renova Auto', align: 'left', minWidth: 200 },
  ]

  useEffect(() => {
    const fetchData = async () => {
      swal.fire({
        html: <FrLoading text="Carregando..." />,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })

      const urlParams = new URLSearchParams(window.location.search);
      let query = paramsToObject(urlParams)

      setComboSed(await api.getComboDataWhere('sedes', "?fk_usu=" + getUserCode()))

      setFilter(query)
      populateForm(document.getElementById('searchForm'), query)

      swal.close()
      if (query.buscar === 'true') {
        let event = new Event('build');
        getData(event)
      }
    }

    fetchData()
  }, [])

  function getData(e) {
    e.preventDefault()
    var formData = new FormData(document.getElementById('searchForm'))
    var queryObject = formToObject(formData)
    queryObject.buscar = true
    if ((!queryObject.dataini_fim) && (!queryObject.datafim_fim)) {
      swal.fire('Atenção', 'Informe o período de vencimento!', 'warning')
    } else {
      try {
        setFiltered(true)
        window.history.replaceState({ filtered: true }, 'filter', "/salute/renova_contratos?" + objectToQueryString(queryObject));
        swal.fire({
          html: <FrLoading text="Buscando dados..." />,
          showConfirmButton: false,
          allowOutsideClick: false,
          allowEscapeKey: false
        })
        api.get('/contratos/buscaRenovacao', { params: queryObject }).then(r => {
          setData(r.data)
          swal.close()
        })
      } catch (error) {
        window.location.reload()
      }
    }
  }


  function clearForm(e) {
    e.preventDefault();
    window.history.replaceState({ filtered: false }, 'filter', '/salute/renova_contratos');
    document.getElementById('searchForm').reset()
    setFilter({})
  }

  const handleChange = (e) => {
    const auxValues = { ...filter };
    switch (e.target.name) {
      default:
        auxValues[e.target.name] = e.target.value;
    }
    setFilter(auxValues);
  };


  return (
    <div className="Manut">
      <NavBar />
      <div className="ManutContent">
        <div className="defaultHeader">
          <h3>Renovação de Contratos</h3>
          <UserOptions temaEscuro={props.temaEscuro} setTemaEscuro={props.setTemaEscuro} />
        </div>
        <br />
        <div className="filtersDiv">
          <form id="searchForm" onSubmit={getData}>
            <div>
              <FrDatePicker
                value={(filter.dataini_fim || '').split('T')[0]}
                name="dataini_fim"
                id="dataini_fim"
                color="#49573B"
                label="Período Vcto Contrato"
                variant="outlined"
                size="small"
                style={{ width: 190 }}
                onChange={handleChange}
                autoFocus
              />

              <label style={{ paddingRight: '7px', paddingTop: '7px' }}>a</label>

              <FrDatePicker
                value={(filter.datafim_fim || '').split('T')[0]}
                name="datafim_fim"
                id="datafim_fim"
                color="#49573B"
                variant="outlined"
                size="small"
                style={{ width: 190 }}
                onChange={handleChange}

              />

              <FrSelect
                value={filter.fk_sed || -1}
                style={{ width: 150 }}
                name="fk_sed"
                id="fk_sed"
                label='Sede'
                data={comboSed}
                onChange={handleChange}
                mostraTodos
              />

              <FrSelect
                value={filter.ativo || -1}
                style={{ width: 150 }}
                name="ativo"
                id="ativo"
                label='Situação'
                data={comboAtivo}
                onChange={handleChange}
                mostraTodos
              />

              <FrSelect
                value={filter.adimplentes || -1}
                style={{ width: 150 }}
                name="adimplentes"
                id="adimplentes"
                label='Adimplentes'
                data={comboAdimplente}
                onChange={handleChange}
                mostraTodos
              />
              <br />


            </div>
            <div>
              <button onClick={getData}>
                <Icon icon={ic_search} size={18} />
                Pesquisar
              </button>
              <button onClick={clearForm}>
                <Icon icon={ic_delete} size={18} />
                Limpar
              </button>
            </div>
          </form>
        </div>

        <div className={"tableDiv" + (props.frame && data.length > 0 ? '-frame' : '')}>
          <FrTable
            width={150}
            historicos={true}
            startOrder='desc'
            startOrderBy='data_fim'
            regName="contratos"
            frame={props.frame}
            columns={columns}
            searched={filtered}
            codeName="pk_cto"
            mostraCheck={"N"}
            renovacao
            page={'contratos'}
            data={data}
            selected={selected}
            setSelected={setSelected}
          />
        </div>
        <FooterDelphus />
      </div>
    </div>
  );
}

export default Contratos;